
export default function FinalCTA() {
  return (
    <section className="bg-[#2E7DD1] py-14">
      <div className="max-w-3xl mx-auto px-4 text-center space-y-6">
        <h4 className="text-3xl font-extrabold text-white">
          <a href="#booking-form" className="hover:text-[#F5A623] transition-colors">
            Ready to Breathe Cleaner Air?
          </a>
        </h4>
        <p className="text-blue-100 text-sm max-w-xl mx-auto">
          Don&apos;t wait — improve your home&apos;s air quality today. Book your service now and experience the Sunshine Air Pros difference.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="tel:3214468130"
            className="inline-flex items-center gap-2 bg-[#F5A623] hover:bg-[#E09500] text-white font-extrabold py-4 px-10 rounded-lg text-lg transition-colors whitespace-nowrap shadow-lg cursor-pointer"
          >
            <i className="ri-phone-fill"></i>
            Call (321) 446-8130
          </a>
          <a
            href="#booking-form"
            className="inline-flex items-center gap-2 bg-transparent border-2 border-white hover:bg-white/10 text-white font-bold py-4 px-10 rounded-lg text-lg transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-calendar-check-fill"></i>
            Book Online Now
          </a>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-6 pt-4 text-blue-100 text-xs">
          <span className="flex items-center gap-1">
            <i className="ri-shield-check-fill text-[#F5A623]"></i> Fully Insured
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-time-fill text-white"></i> Next-Day Service
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-award-fill text-[#F5A623]"></i> Warranty Backed
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-money-dollar-circle-fill text-white"></i> Money-Back Guarantee
          </span>
        </div>
      </div>
    </section>
  );
}
